import { createContext, useMemo } from "react";
import { useAuth } from "react-oidc-context";

// const API_ORIGIN = "https://api.minecraft.atfares17.net";
const API_ORIGIN =
  "https://5regrvoxrf.execute-api.eu-north-1.amazonaws.com/production";

export type ApiOperations = {
  get: <T>(path: string) => Promise<T | null>;
  post: <T = void>(path: string, body?: object) => Promise<T>;
  put: <T = void>(path: string, body?: object) => Promise<T>;
  patch: <T = void>(path: string, body: object) => Promise<T>;
  delete: (path: string) => Promise<void>;
};

const useApi: () => ApiOperations = () => {
  const auth = useAuth();

  const id_token = auth.user!.id_token!;

  function baseOptions(
    method: "GET" | "POST" | "PATCH" | "PUT" | "DELETE"
  ): RequestInit {
    return {
      method,
      headers: { authorization: `Bearer ${id_token}` },
    };
  }

  async function finish(response: Response) {
    if (!response.ok) {
      throw new Error(
        `API request failed: ${response.status} ${response.statusText}`
      );
    }
    return response.status === 200 ? await response.json() : null;
  }

  async function getImpl(path: string) {
    var response = await fetch(`${API_ORIGIN}/${path}`, baseOptions("GET"));
    return await finish(response);
  }

  async function postImpl(path: string, body?: object) {
    const options = baseOptions("POST");
    if (body !== undefined) {
      options.headers["content-type"] = "application/json";
      options.body = JSON.stringify(body);
    }
    var response = await fetch(`${API_ORIGIN}/${path}`, options);
    return await finish(response);
  }

  async function putImpl(path: string, body?: object) {
    const options = baseOptions("PUT");
    if (body !== undefined) {
      options.headers["content-type"] = "application/json";
      options.body = JSON.stringify(body);
    }
    var response = await fetch(`${API_ORIGIN}/${path}`, options);
    return await finish(response);
  }

  async function patchImpl(path: string, body: object) {
    const options = baseOptions("PATCH");
    options.headers["content-type"] = "application/json";
    options.body = JSON.stringify(body);
    var response = await fetch(`${API_ORIGIN}/${path}`, options);
    return await finish(response);
  }

  async function deleteImpl(path: string) {
    var response = await fetch(`${API_ORIGIN}/${path}`, baseOptions("DELETE"));
    return await finish(response);
  }

  return {
    get: useMemo(() => getImpl, [auth]),
    post: useMemo(() => postImpl, [auth]),
    put: useMemo(() => putImpl, [auth]),
    patch: useMemo(() => patchImpl, [auth]),
    delete: useMemo(() => deleteImpl, [auth]),
  };
};

export default useApi;
